// extracted by mini-css-extract-plugin
export var container = "_gg-0";
export var content = "_gg-3";
export var customerTitle = "_gg-4";
export var empty = "_gg-5";
export var gray = "_gg-6";
export var header = "_gg-7";
export var info = "_gg-8";
export var loading = "_gg-2";
export var loadingCard = "_gg-9";
export var oneLine = "_gg-a";
export var personName = "_gg-e";
export var pillContainer = "_gg-b";
export var selected = "_gg-1";
export var text = "_gg-c";
export var twoLines = "_gg-d";
export var unread = "_gg-f";
export var unreadIndicator = "_gg-g";